// extracted by mini-css-extract-plugin
module.exports = {"discountButton":"EsimBanner-module__discountButton___qI4B2"};